// importing actions
import {
  LOAD_LABX_ORDERS,
  LOAD_USSD_ORDERS,
  LOAD_CALL_ORDERS,
  LOAD_BOAT_ORDERS,
  LOAD_ONGOING_ORDERS,
  LOAD_EMERGENCY_ORDERS,
  LOAD_OVERDUE_ORDERS,
  LOAD_COMPLETED_ORDERS,
  LOAD_SCHEDULE_ORDERS,
  LOAD_HOSPITAL_LIST,
  LOAD_HOSPITAL,
  LOAD_DISPATCH_LIST,
  LOAD_LAB_LIST,
  CLOSE_ORDER,
  PROCESS_ORDER,
  PROCESS_SCHEDULED,
  LOAD_OXYGEN_LIST,
  TRACK_ORDER,
  ORDER_PRICE,
  LOAD_RIDERS,
  STOCKBANK_PRODUCTS,
  QUIP_PRODUCTS,
  NOTIFICATIONS,
  VIEW_NOTIFICATION,
  UPDATE_ORDER,
  CHECKER,
  POD_CHECK,
} from "../../types";

// state
const INITIAL_STATE = {
  labxOrders: { nerve: [], ussd: [], boat: [] },
  ongoing: [],
  extra: [],
  overdue: [],
  ussd: { nerve: [], ussd: [], boat: [] },
  call: { nerve: [], ussd: [], boat: [] },
  boat: { nerve: [], ussd: [], boat: [] },
  completed: [],
  scheduled: [],
  hospital: [],
  stockHospital: [],
  labs: [],
  riders: null,
  pod: {},
  toBuy: {},
  closed: {},
  checker: [],
  precheck: { vendor: [], Dispatch: [] },
  oxygen: [],
  track: {},
  price: {},
  rider: [],
  stockbankProducts: [],
  quipProducts: [],
  notifications: [],
  updateOrder: [],
};

// Redux reducer function
const orderReducer = (state = INITIAL_STATE, action) => {
  // Destructuring action
  const { type, payload } = action;

  switch (type) {
    case LOAD_LABX_ORDERS:
      return {
        ...state,
        labxOrders: payload,
      };
    case POD_CHECK: 
      return {
        ...state,
        pod: payload,
      };
    case LOAD_USSD_ORDERS:
      return {
        ...state,
        ussd: payload,
      };

    case LOAD_CALL_ORDERS:
      return {
        ...state,
        call: payload,
      };

    case LOAD_BOAT_ORDERS:
      return {
        ...state,
        boat: payload,
      };

    case LOAD_ONGOING_ORDERS:
      return {
        ...state,
        ongoing: payload,
      };

    case LOAD_EMERGENCY_ORDERS:
      return {
        ...state,
        extra: payload,
      };

    case LOAD_OVERDUE_ORDERS:
      return {
        ...state,
        overdue: payload,
      };

    case LOAD_COMPLETED_ORDERS:
      return {
        ...state,
        completed: payload,
      };

    case LOAD_SCHEDULE_ORDERS:
      return {
        ...state,
        scheduled: payload,
      };

    case LOAD_HOSPITAL_LIST:
      return {
        ...state,
        hospital: payload,
      };

    case LOAD_HOSPITAL:
      return {
        ...state,
        stockHospital: payload,
      };

    case LOAD_DISPATCH_LIST:
      return {
        ...state,
        riders: payload,
      };

    case LOAD_LAB_LIST:
      return {
        ...state,
        labs: payload,
      };

    case LOAD_OXYGEN_LIST:
      return {
        ...state,
        oxygen: payload,
      };

    case CLOSE_ORDER:
      return {
        ...state,
        closed: payload,
      };

    case CHECKER:
      return {
        ...state,
        checker: payload,
      };

    case PROCESS_ORDER:
      return {
        ...state,
        precheck: payload,
      };

    case PROCESS_SCHEDULED:
      return {
        ...state,
        precheck: payload,
      };

    case TRACK_ORDER:
      return {
        ...state,
        track: payload,
      };

    case ORDER_PRICE:
      return {
        ...state,
        price: payload,
      };

    case LOAD_RIDERS:
      return {
        ...state,
        rider: payload,
      };

    case STOCKBANK_PRODUCTS:
      return {
        ...state,
        stockbankProducts: payload,
      };

    case QUIP_PRODUCTS:
      return {
        ...state,
        quipProducts: payload,
      };

    case NOTIFICATIONS: {
      const next = Array.isArray(payload) ? payload : [];
      const prev = state.notifications || [];

      // Build lightweight signatures to detect real changes and avoid unnecessary state updates
      const sig = (arr) =>
        arr
          .map((n) =>
            n && typeof n === "object"
              ? `${n.id ?? ""}:${n.viewed ? 1 : 0}`
              : String(n)
          )
          .sort()
          .join("|");

      const prevSig = sig(prev);
      const nextSig = sig(next);

      if (prevSig === nextSig) {
        // No meaningful change; keep same state reference to prevent rerenders elsewhere
        return state;
      }

      return {
        ...state,
        notifications: [...next],
      };
    }

    case VIEW_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload.id
            ? { ...notification, viewed: true } // Return a new object
            : notification
        ),
      };

    case UPDATE_ORDER:
      return {
        ...state,
        updateOrder: payload,
      };

    default:
      return state;
  }
};

export default orderReducer;

// const info = [
//   {
//     label: 'PRoDUCTS',
//     Text: 'BLOOD',
//   },
//   {labkle: }
// ]
